import { configs } from '../../server/RestClients';

const defaultState = {
  configs,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const configsSelector = (state) => state.servicesConfigs.configs;
